import React from "react";

const SearchTour = () => {
  return (
    <div>
      <p>
        Quickly find any application by typing its name in the search bar.
      </p>
    </div>
  );
};

export default SearchTour;
